export default class DocHubClient {
	static connection = null;

	static setConnection(value) {
		this.connection = value;
	}

	static getConnection() {
		return this.connection;
	}

	static getConnectionId() {
		if (!this.connection) return '';

		const {id, connectionId = id} = this.connection;

		return connectionId;
	}
}
